import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";

@Component({
    selector: 'app-numeric-input',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule
    ],
    templateUrl: './numeric-input.component.html',
    styleUrls: ['./numeric-input.component.scss']
})
export class NumericInputComponent {
    @Input() valueFormControl! : FormControl<number | null>;
    @Input() placeholderValue = '';
    @Input() minValue!: number;
    @Input() maxValue!: number;
}
